import HeaderLink from "./HeaderLink";
import PlainLink from "./PlainLink";

export function ProductReturnRequestFragment() {
  return (
    <>
      <HeaderLink to="/ProductReturnRequest/index">Zwroty towarów</HeaderLink>

      <PlainLink to="/ProductReturnRequest/new">Nowy wniosek</PlainLink>
    </>
  );
}
